module.exports = __webpack_public_path__ + "33c8195ee32dc1ea75f86a3c8f8f96de.svg";